import { XMLToJSON } from 'helpers/xmlToJson';
import { convertToObject } from 'utils/arrayConverted';


interface Cell {
    _: string;
}

interface Column {
    _: string;
}

interface Row {
    cell: Cell[];
}

interface Head {
    column: Column[];
}

interface DataConverted {
    rows: {
        head: Head[];
        row: Row[];
    };
}

export const processXMLData = async (data: string) => {
    try {
     
        const dataConverted: DataConverted = await XMLToJSON(data);

        const dataHeaders = dataConverted.rows.head[0]?.column.map(item => item._);
        
        const dataRows = dataConverted.rows.row.map(row => row.cell);

        const generateArray=  convertToObject(dataHeaders, dataRows);

        return generateArray;

    } catch (error) {
        //console.warn('warning processing data:', error);
    }
} 

